"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModal = exports.StyledButton = exports.StyledSpan = exports.AddOnContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importDefault(require("@kyruus/button"));
const modal_1 = __importDefault(require("@kyruus/modal"));
exports.AddOnContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.StyledSpan = styled_1.default.span `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.StyledButton = (0, styled_1.default)(button_1.default) `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  padding: 0px;
  &:hover,
  &:focus {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    text-decoration: underline;
    border-color: transparent;
  }
  text-align: left;
`;
exports.StyledModal = (0, styled_1.default)(modal_1.default) `
  h1 {
    line-height: normal;
  }
  p {
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
//# sourceMappingURL=styles.js.map